import { styled } from '@linaria/react';
const StyledCheckbox = /*#__PURE__*/styled('label')({
  name: "StyledCheckbox",
  class: "s1icd1ox",
  propsAsIs: false
});
export default StyledCheckbox;

require("./Checkbox.styles.linaria.module.css");